'use client';
import Image from 'next/image';
const speakers = [
 {
     name: "Rebecca Dance Shuker",
     designation: "CoFounder",
     company: "s-inc.world",
     imageSrc: "/images/speakers/rebeca-new.webp",
     alt: "Maurizio-Barbieri",
   },
   {
     name: "Bertie Wrench",
     designation: "Founder",
     company: "Bad Bikers and Death Race",
     imageSrc: "/images/speakers/bertie-wrench-croped.webp",
     alt: "bertie-wrench",
   },
   {
     name: "Katerina Zemskova",
     designation: "Head of Agency",
     company: "Formula by Cointelegraph",
     imageSrc: "/images/speakers/katerina.webp",
     alt: "katerina",
   },
  //  end of 2025 speakers
  {
    name: "Maurizio Barbieri",
    designation: " Founder & CEO",
    company: "TIFO",
    imageSrc: "/images/speakers/maurizio.webp",
    alt: "Maurizio-Barbieri",
  },
  {
    name: "Greg Marlin",
    designation: "CTO",
    company: "zkCandy",
    imageSrc: "/images/speakers/greg.webp",
    alt: "GregMarlin",
  },
   {
    name: "Stainslaw Fiedor",
    designation: "CBDO",
    company: "Elympics.ai",
    imageSrc: "/images/speakers/stainslaw-fieder.webp",
    alt: "Stainslaw Fiedor",
  },
   {
    name: "Alexander Belov",
    designation: "Forbes journalist",
    company: "Coinstelegram Media & Fund ",
    imageSrc: "/images/speakers/alexander-belov.webp",
    alt: "AlexanderBelov",
  },
];
const SpeakerSection = () => {
  return (
    <section id='speakers' className="w-full bg-White p-6 sm:p-8 md:p-10 lg:p-[38px] sm:p-4"
    >
      <div className="w-full max-w-[1100px] mx-auto">
        {/* Section Title */}
         <h2
              className="text-[24px] sm:text-[30px] md:text-[34px] lg:text-[38px] font-bold text-center text-text-primary mb-10"
              style={{ fontFamily: 'Montserrat' }}
            >
              Past Speakers
            </h2>
        {/* Speaker List Box */}
        <div className="w-full  max-w-[1230px] mx-auto">
          {/* Mobile gap-5 and larger screens gap-2 */}
          <div className="grid grid-cols-2 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-2 sm:gap-2 place-items-center">
            {speakers.map((speaker, index) => (
              <div key={index} className="flex flex-col items-center">
                {/* Adjusted Image Container for smaller mobile sizes */}
                <div className="w-[150px] h-[150px] sm:w-[250px] sm:h-[250px] relative mb-4">
                  <Image
                    src={speaker.imageSrc}
                    alt={speaker.alt}
                    height={200}
                    width={200}
                    objectFit="cover"
                    unoptimized
                    className="rounded-full w-[150px] h-[150px] sm:w-[250px] sm:h-[250px] "
                  />
                </div>
                <h3 className="text-[#000] text-[16px] sm:text-[18px] font-semibold text-center mb-1">
                  {speaker.name}
                </h3>
                <p className="text-black text-[12px] sm:text-[14px] text-center mb-1">
                  {speaker.designation}
                </p>
                <p className="text-black text-[10px] sm:text-[12px] text-center">
                  {speaker.company}
                </p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};
export default SpeakerSection;
/////////////////////////////////////////////////////






